// extracted by mini-css-extract-plugin
module.exports =  {"Block":"Block__oz0MD","noMarginTop":"noMarginTop__dMn3V","noMarginBottom":"noMarginBottom__z-qbR","border":"border__77f26"};